import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { CurrencyPipe, DialogBase, ObjectTypeInfo, T4RentalService } from 't4core';
import { RentalObjectInfo, SparepartPriceModel } from '../../../../../projects/t4core/src/public-api';
import { T4DatatableWidget } from '../../../../t4common/components/datatable/datatable';

@Component({
  selector: 't4-CostListDialog',
  templateUrl: 'CostListDialog.html',
})
export class CostListDialog extends DialogBase implements OnInit {
  public rentalId: number = 0;
  public loading: boolean = false;
  public isCostAdded: boolean = false;
  @ViewChild("tblCosts", { static: false }) private tblCosts: T4DatatableWidget;
  constructor(public dialogRef: MatDialogRef<CostListDialog>, @Inject(MAT_DIALOG_DATA) public data: any, private rentalService: T4RentalService, private cPipe: CurrencyPipe) {
    super("CostListDialog");

    this.rentalId = data.rentalId;
  }

  async ngOnInit() {
    this.loading = true;
    console.log(this.data);
    this.loading = false;
  }

  public save() {
    this.dialogRef.close(this.isCostAdded);
  }

  public async addCost() {
    this.tblCosts.isLoading = true;
    var ret = await this.UI.openDialog("T4.Bookings.AddCostDialog", { data: { rentalId: this.rentalId, isSparePartsDefault: true } });    
    this.tblCosts.update();
    this.tblCosts.isLoading = false;
    if (ret)
      this.isCostAdded = true;
  }

  public close() {
    this.dialogRef.close(this.isCostAdded);
  }

  public static async open(dialog: MatDialog, _bookingId: number = null) {
    var dlg = dialog.open(CostListDialog, {
      maxHeight: "calc(100vh - 20px)",
      maxWidth: "calc(100vw - 20px)",
      width: "400px",
      data: {
        rentalId: _bookingId
      }
    });
  }
}
